import { Spinner } from '#assets/Spinner.tsx';
import styles from './Waiting.module.css';

// A small "still working" indicator: spinner + label, used while waiting for a host to connect
// (GetStarted) and while a host + enrollment code are being created (InstallSection). When
// `connected` is set the spinner flips to its success checkmark — the brief "connected!" beat
// before the flow advances.
export function Waiting({ label, connected = false }: { label: string; connected?: boolean }) {
  return (
    <div className={styles.Waiting_root}>
      <Spinner size={16} state={connected ? 'success' : 'spinning'} />
      {label}
    </div>
  );
}
